import React, { useState } from 'react';
import { Link } from "react-router-dom";
import { CheckCircleIcon } from "@heroicons/react/24/outline"

const Status = () => {
    const [message] = useState('Order Placed Successfully!');

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-r from-green-500 to-teal-600 text-white p-6">
            <div className="bg-white text-gray-800 rounded-2xl shadow-xl p-8 max-w-lg w-full text-center transform transition-all duration-300 ease-in-out hover:scale-105">
                <CheckCircleIcon className="w-20 h-20 text-green-500 mx-auto mb-4" />
                <h2 className="text-2xl font-bold mb-4">{message}</h2>
                
                <p className="text-gray-600 mb-6 text-lg">Your order has been placed successfully! We are processing your order and will notify you once it is shipped. Thank you for shopping with us! <b>Please send your prescription to <a href="mailto:spectsgenie.in@gmail.com">spectsgenie.in@gmail.com</a></b></p>
                
                <div className="">
                    <Link to="/" state={{ message: "Continue shopping to explore more products." }}>
                        <button className="px-6 py-3 bg-gradient-to-r from-green-500 to-teal-600 text-white font-semibold rounded-lg shadow-md hover:from-green-600 hover:to-teal-700 transition-all duration-300">
                            Continue Shopping
                        </button>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default Status;
